import { Box, Typography } from "@mui/material";
import ParticleBackground from "../components/common/ParticleBackground";

export default function Pending() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Typography variant="h3" sx={{ color: "#fff", mb: 2 }}>
        ⏳ Pago pendiente
      </Typography>

      <Typography sx={{ color: "#aaa" }}>
        Estamos esperando la confirmación del pago
      </Typography>
    </Box>
  );
}